import React from 'react';
import { Icon } from '@iconify/react';

const AreaDataTable = ({ areas, onEdit, onDelete, canEdit = true, canDelete = true }) => {
  return (
    <table className="table bordered-table mb-3" style={{ width: '100%', borderRadius: '0' }}>
      <thead>
        <tr>
          <th style={{ borderRadius: '0' }}></th>
          <th>Code</th>
          <th>Name</th>
          <th>Description</th>
          <th>Department</th>
          <th>Team</th>
          <th>Cost Center</th>
          <th style={{ borderRadius: '0' }}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {areas.length === 0 && (
          <tr>
            <td colSpan="8" className="text-center py-4 rounded-0">No Areas Loaded</td>
          </tr>
        )}
        {areas.map((row) => {
          const imageUrl = row.image
            ? `${process.env.REACT_APP_SPACES_BASE}/${row.image}`
            : `${process.env.REACT_APP_SPACES_BASE}/placeholder.png`;
          return (
            <tr key={row.id}>
              <td>
                <img
                  src={imageUrl}
                  alt="area"
                  style={{
                    width: '45px',
                    height: '45px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    border: '1px solid #ddd',
                  }}
                />
              </td>
              <td><strong>{row.areaCode}</strong></td>
              <td>{row.name}</td>
              <td>{row.description}</td>
              <td>{row.department?.name}</td>
              <td>{row.team?.teamName}</td>
              <td>{row.costCenter?.costCenterDescription}</td>
              <td>
                <div className="d-flex gap-2">
                  {canEdit && (
                    <button
                      className="w-32-px h-32-px bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                      onClick={() => onEdit(row)}
                    >
                      <Icon icon="ic:baseline-edit" className="icon text-xl line-height-1" />
                    </button>
                  )}
                  {canDelete && (
                    <button
                      className="w-32-px h-32-px bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                      onClick={() => onDelete(row.id)}
                    >
                      <Icon icon="ic:baseline-delete-outline" className="icon text-xl line-height-1" />
                    </button>
                  )}
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default AreaDataTable;
